import { CRUDAction, FeatureKey } from 'common/constants/permission'
import useMedia from 'common/hooks/useMedia'
import { usePermitToActionFeature } from 'modules/user/api/selector'
import { useTranslation } from 'react-i18next'

import { Box, Grid } from '@mui/material'

import { RecordFeatureButton } from 'components/RecordFeatureButton'

import CostCard from '../CostCard'
import CostDialogCreateUpdate from '../CostDialogCreateUpdate'
import CostGroupSection from '../CostGroupSection'
import CostTable from '../CostTable'

const Cost = () => {
  const { t } = useTranslation('cost')
  const isMobile = useMedia('sm')
  const showRecordBtn = usePermitToActionFeature([CRUDAction.Create], FeatureKey.Cost)
  return (
    <Box sx={{ py: isMobile ? 0 : 3 }}>
      <RecordFeatureButton
        buttonText={t('record.costs')}
        dialog={({ open, onClose }) => <CostDialogCreateUpdate open={open} onClose={onClose} />}
        showButton={showRecordBtn}
      />
      <Grid container>
        <Grid item xs={12}>
          <CostCard />
        </Grid>
        <Grid item xs={12}>
          <CostGroupSection />
        </Grid>
        <Grid item xs={12} sx={{ mt: 4 }}>
          <CostTable />
        </Grid>
      </Grid>
    </Box>
  )
}

export default Cost
